import Mailcheck from 'mailcheck';
import React from 'react';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { Link } from 'react-router-dom';
import {
  Col,
  Input,
  Modal,
  ModalBody,
  Row,
  UncontrolledTooltip,
} from 'reactstrap';

import StripeImg from '../../../assets/img/powered_by_stripe@3x.png';
import countryCodes from '../../../assets/js/countryCodes';
import { AudioMessage } from '../../AudioMessage/AudioMessage';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import ElementCard from './ElementCard';
import ModalCoupon from './ModalCoupon/ModalCoupon';

const pwLogo = require('../../../assets/img/brand/logo.png');

// This is displayed in Sign Up
class SubscriptionBillingModal extends React.Component {
  constructor(props) {
    super(props);
    this.cardElement = null;
    this.state = {
      cardMounted: false,
      tax: 0,
      email: '',
      emailError: { isError: false, message: '' },
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      phoneNumber: '',
      highestEducationLevel: '',
      currentEnrollmentStatus: '',
      country: 'United States',
      countryCode: '+1',
      countryShortCode: 'US',
      zip: '',
      state: '',
      card: this.props.card || '',
      showPassword: false,
      passwordInputType: 'password',
      passwordError: false,
      password: '',
      emailExistsError: false,
      disclaimer: false,
      textRed: false,
      selectedPlan: { id: '' },
      couponCode: '',
      planChanged: false,
      couponChanged: false,
      isLoadingTokenCard: false,
      tokenCard: '',
      errorMessage: '',
      errors: {},
      missingFields: [],
      couponInvalid: false,
      verifyCoupon: true,
      emailSuggestion: { isSuggestion: false, suggestion: '' },
      showInput: false,
      isInputDisabled: false,
      showMonthlyConfirmation: false,
      pendingMonthlyPlan: null,
      highlightPlanSelector: false,
    };

    // Create ref for plan selector
    this.planSelectorRef = React.createRef();
  }

  handleCardReady = (element) => {
    this.cardElement = element;
  };

  resetModal = () => {
    this.onChange(
      {
        // cardMounted: false,
        tax: 0,
        email: '',
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        country: 'United States',
        countryCode: '+1',
        countryShortCode: 'US',
        zip: '',
        state: '',
        card: '',
        showPassword: false,
        passwordInputType: 'password',
        passwordError: false,
        password: '',
        emailExistsError: false,
        emailError: { isError: false, message: '' },
        phoneNumber: '',
        highestEducationLevel: '',
        currentEnrollmentStatus: '',
        showMonthlyConfirmation: false,
        pendingMonthlyPlan: null,
        highlightPlanSelector: false,
      },
      true,
    );
    this.props.setCheckEmailExistsMessage({ exists: false, requested: false });
    this.props.onClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.subscriptionMessage !== nextProps.subscriptionMessage &&
      nextProps.subscriptionMessage !== ''
    ) {
      if (this.cardElement) {
        this.cardElement.clear();
      }
      this.setState({
        tokenCard: '',
        zip: '',
      });
    }

    if (nextProps.checkEmailExistsMessage.requested) {
      this.props.setCheckEmailExistsMessage({
        exists: nextProps.checkEmailExistsMessage.exists,
        requested: false,
      });
      if (nextProps.checkEmailExistsMessage.exists) {
        this.setState({
          emailExistsError: true,
        });
        this.props.setSubscriptionWaiting(false);
      } else {
        this.setState({ emailExistsError: false });

        const subscriptionData = {
          ...this.state,
          ccName:
            `${this.state.firstName.trim()} ${this.state.lastName.trim()}`.trim(),
        };

        this.props.onUpdate(subscriptionData);
        this.props.makeSubscription(subscriptionData);
      }
    }
    if (nextProps.coupon && this.state.planChanged)
      this.setState({ planChanged: false, couponChanged: false });

    if (nextProps.coupon.invalid) {
      this.setState({ couponInvalid: true });
      this.setState({ couponCode: '' });
    }

    if (nextProps.coupon.name) {
      this.setState({ isInputDisabled: true });
    }
  }

  onChange = (values, sendToParent = false) => {
    this.setState(values);
    if (sendToParent) {
      this.props.onUpdate(values);
    }

    // remove error when changed is value
    if (this.state.emailError.isError && values.email) {
      this.setState({
        emailError: { isError: false, message: '' },
        emailExistsError: false,
      });
    } else if (this.state.passwordError && values.password) {
      this.setState({
        passwordError: false,
      });
    }
  };

  onBlurCheck = (value) => {
    if (value.email) {
      // validate email errors
      const validatorEmail = this.isValidEmail(this.state.email);
      this.setState({
        emailError: validatorEmail,
      });

      if (validatorEmail.isError) {
        this.setState({
          validEmail: false,
          emailErrorText: validatorEmail.message,
        });
      } else {
        // if not email errors, validate email suggestions
        const domains = [
          'gmail.com',
          'yahoo.com',
          'hotmail.com',
          'outlook.com',
        ];
        const secondLevelDomains = ['hotmail', 'live'];
        const topLevelDomains = ['com', 'net', 'org', 'edu', 'mil'];

        let suggestionEmail = '';
        Mailcheck.run({
          email: this.state.email,
          domains,
          secondLevelDomains,
          topLevelDomains,
          suggested(suggestion) {
            if (suggestion) {
              suggestionEmail = suggestion.full;
            }
          },
          empty() {
            // this is executed if there is not suggestions
          },
        });
        if (suggestionEmail && suggestionEmail !== this.state.email) {
          this.setState({
            validEmail: true,
            emailSuggestion: {
              isSuggestion: true,
              suggestion: suggestionEmail,
            },
          });
        } else {
          this.setState({
            validEmail: true,
            emailSuggestion: {
              isSuggestion: false,
              suggestion: '',
            },
          });
        }
      }
    } else if (value.password) {
      const validPassword = this.isValidPassword(this.state.password);
      this.setState({
        passwordError: false,
        emailExistsError: false,
        emailSuggestion: { isSuggestion: false, suggestion: '' },
      });
      if (!validPassword) {
        this.setState({
          passwordError: true,
        });
      }
    }
  };

  togglePasswordVisibility = () => {
    const newType = this.state.showPassword ? 'password' : 'text';
    this.setState({
      showPassword: !this.state.showPassword,
      passwordInputType: newType,
    });
  };

  selectRegion = (val) => {
    this.onChange({ state: val, zip: '', tax: 0 });
  };

  selectCountry = (val) => {
    this.onChange({
      country: val,
      state: '',
      zip: '',
      address: '',
      city: '',
      tax: 0,
    });
  };

  componentWillUnmount() {
    this.resetModal();
  }

  validateField = () => {
    const errors = {};
    const missingFields = [];
    this.firstInvalidField = null;

    const validate = (name, value, ref) => {
      if (value === '') {
        errors[name] = 'This field is required';
        missingFields.push(name);
        if (!this.firstInvalidField) {
          this.firstInvalidField = ref;
        }
      }
    };

    validate('email', this.state.email, this.emailInput);
    validate('password', this.state.password, this.passwordInput);
    validate(
      'selectedPlan',
      this.state.selectedPlan.id,
      this.selectedPlanInput,
    );
    if (
      !this.props.coupon ||
      this.props.coupon.invalid ||
      !this.props.coupon.percentageOff ||
      this.props.coupon.percentageOff < 100
    ) {
      validate('firstName', this.state.firstName, this.firstNameInput);
      validate('lastName', this.state.lastName, this.lastNameInput);
      validate('address', this.state.address, this.addressInput);
      validate('city', this.state.city, this.cityInput);
      validate('state', this.state.state, this.stateSelectInput);
      validate('country', this.state.country, this.countrySelectInput);
      validate('tokenCard', this.state.tokenCard, this.cardNumberInput);
    }
    validate(
      'currentEnrollmentStatus',
      this.state.currentEnrollmentStatus,
      this.currentEnrollmentStatusSelectInput,
    );
    validate(
      'highestEducationLevel',
      this.state.highestEducationLevel,
      this.highestEducationLevelSelectInput,
    );

    this.setState({ errors, missingFields });

    if (this.firstInvalidField) {
      this.firstInvalidField.focus();
    }
    return missingFields.length === 0 && this.state.disclaimer;
  };

  validateData = (verifyCoupon) => {
    if (!this.validateField()) {
      return false;
    }

    if (this.state.couponCode === '') {
      this.setState({
        couponCode: '',
        couponInvalid: false,
        isInputDisabled: false,
      });
    }

    this.setState({
      errorMessage: '',
      emailError: { isError: false, message: '' },
      passwordError: false,
      emailExistsError: false,
    });
    this.props.setSubscriptionWaiting(true);
    this.props.setSubscriptionMessage('');

    const validPassword = this.isValidPassword(this.state.password);

    const validatorEmail = this.isValidEmail(this.state.email);

    this.setState({
      emailError: validatorEmail,
    });

    if (!this.state.disclaimer) {
      return false;
    }

    if (!validatorEmail.isError) {
      if (validPassword) {
        this.setState({
          passwordError: false,
          emailExistsError: false,
        });
        if (
          this.state.couponCode !== '' &&
          this.props.coupon &&
          this.props.coupon.invalid &&
          verifyCoupon
        ) {
          this.props.setSubscriptionWaiting(false);
          this.setState({ couponInvalid: true });
          return false;
        }
        this.props.checkEmailExists(this.state.email);
      } else {
        this.setState({
          passwordError: true,
        });
        this.props.setSubscriptionWaiting(false);
      }
    } else {
      this.props.setSubscriptionWaiting(false);
    }
  };

  setTextRed = () => {
    this.setState({ textRed: true });
  };

  checkCoupon = (plan) => {
    const { selectedPlan, couponChanged, verifyCoupon } = this.state;
    let { couponCode } = this.state;

    const planId = plan ? plan.id : selectedPlan.id;

    if (!verifyCoupon) {
      couponCode = '';
    }
    if (planId === '' || couponCode === '' || (!couponChanged && !plan)) return;
    this.props.checkCoupon(couponCode, planId, true);
  };

  handlePlanSelection = (planId) => {
    const selectedPlan = this.props.plans.find((p) => p.id === planId);
    this.selectPlan(selectedPlan);
  };

  // Actually set the selected plan
  selectPlan = (planId) => {
    this.onChange({
      selectedPlan: planId,
      planChanged: true,
    });
    this.checkCoupon(planId);
  };

  isValidPassword = (password) => {
    let criteria = 0;

    if (/[a-z]/.test(password)) {
      // has lower case letters
      criteria++;
    }
    if (/[A-Z]/.test(password)) {
      // has upper case letters
      criteria++;
    }
    if (/^[a-zA-Z0-9]*$/.test(password) === false) {
      // has special characters
      criteria++;
    }
    if (/\d/.test(password) === true) {
      // has numbers
      criteria++;
    }
    // returns true if 3 or more criteria was met and length is appropriate
    if (criteria < 3 || password.length < 8) {
      return false;
    }
    return true;
  };

  isValidEmail = (email) => {
    this.setState({
      emailError: { isError: false, message: '' },
      emailExistsError: false,
    });

    // Email must be like = 'nameText' + '@' + 'domainText' + '.anything' expect ".con", ".cm"

    // regex to  extrict format "name@domain."
    const firtsRegex = /^[^@]+@[a-zA-Z0-9-]+\./;
    if (!firtsRegex.test(email)) {
      return {
        isError: true,
        message: 'Email must be like "name@domain.com"',
      };
    }

    // regex to avoid .con and .cm
    const secondRegex = /\.(con|cm)$/;
    if (secondRegex.test(email)) {
      const invalidText = email.split('.').pop();
      return {
        isError: true,
        message: `.${invalidText} is not valid`,
      };
    }

    // To avoid use "+" in name
    const nameText = email.split('@')[0];
    if (nameText.includes('+')) {
      return {
        isError: true,
        message: 'Email must not contain the "+" symbol',
      };
    }

    return {
      isError: false,
      message: '',
    };
  };

  renderToolTip() {
    return (
      <UncontrolledTooltip
        placement="left-start"
        target="warning-icon"
        autohide={false}
      >
        <div className="textAlignToolTip">
          <span className="fontToolTip">
            Your password must have at least 8 characters and 3 of the 4 next
            requirements:
          </span>
          <ul>
            <li>Numeric digits (0-9)</li>
            <li>Uppercase alphabetic characters</li>
            <li>Lowercase alphabetic characters</li>
            <li>Non-alphanumeric special characters such as !, $, # or %.</li>
          </ul>
        </div>
      </UncontrolledTooltip>
    );
  }

  dataCard = (value) => {
    if (value) {
      // clear previous request error message
      this.props.setSubscriptionMessage('');

      this.setState({
        card: value.element,
        zip: value.zip,
        tokenCard: value.tokenCard,
      });
    }
  };

  errorMessage = (value) => {
    this.setState({ errorMessage: value });
  };

  fieldIsRequired = (name) => {
    if (this.state.missingFields.includes(name)) {
      return {
        border: '1px solid red',
      };
    }
    return {
      border: '',
    };
  };

  renderButtonText = () => {
    const isLoadingTokenCard = this.state.isLoadingTokenCard;
    const isSubscriptionWaiting = this.props.subscriptionWaiting;

    if (isLoadingTokenCard) {
      return (
        <>
          <span>Validating Card</span>
          <CircularLoading
            className="loading-gif-waiting"
            height="24px"
            width="24px"
          />
        </>
      );
    }
    if (isSubscriptionWaiting) {
      <CircularLoading className="loading-gif-waiting" />;
    }

    return 'Sign up now';
  };

  render() {
    const isFirefox =
      window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    const { coupon } = this.props;
    const { couponCode, selectedPlan } = this.state;
    const isFullDiscount = coupon?.percentageOff === 100;

    let totalCharge = selectedPlan.amount
      ? (selectedPlan.amount / 100).toFixed(2)
      : '';
    const cardData = {
      address_line1: this.state.address,
      address_city: this.state.city,
      address_state: this.state.state.name,
      address_country: this.state.country,
      name: `${this.state.firstName.trim()} ${this.state.lastName.trim()}`.trim(),
    };
    if (coupon.name === couponCode) {
      if (coupon.amountOff > 0)
        totalCharge = (totalCharge - coupon.amountOff).toFixed(2);
      else if (coupon.percentageOff > 0)
        totalCharge = (
          (totalCharge * (100 - coupon.percentageOff)) /
          100
        ).toFixed(2);
    }

    const showCoupon =
      (couponCode === coupon.name && !this.state.planChanged) ||
      (couponCode !== '' && coupon && coupon.invalid);

    let styleEmailInput = 'form-control';
    if (this.state.emailExistsError || this.state.emailError.isError) {
      styleEmailInput = 'input-error form-control';
    } else if (this.state.email && this.state.emailSuggestion.isSuggestion) {
      styleEmailInput = 'input-suggestion form-control';
    }

    const showPlans =
      this.props.rate.isPfeOnly || this.props.questionsOccupationalCounter === 0
        ? this.props.plans.filter((p) => !p.isOccupational)
        : this.props.plans;

    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          toggle={() => {
            this.resetModal();
            this.props.onClose();
          }}
          className="subscription-billing-popup modal-dialog-centered"
          modalClassName="subscription-billing-modal"
        >
          <ModalBody className="subscription-billing-modal-body">
            <Row>
              <Col className="photo-col" sm={6}>
                <div className="planInfo">
                  <div className="planPrice">3 Day Free Trial</div>
                  <div className="freeTrialReminder">
                    No charge today. Cancel anytime.
                  </div>
                </div>
                <div className="imgContainer">
                  <div
                    alt="Bluejacketeer-logo"
                    className="shadow-lg logo-bj"
                    style={{
                      backgroundImage: `url(${pwLogo})`,
                      height: '14rem',
                      width: '14rem',
                    }}
                  />
                </div>
                {/* CHARGES */}
                {selectedPlan.id === '' ? (
                  <>
                    <div className="charges row">
                      <div className="charge-title">Select a Pricing Plan</div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="charges row">
                      <div className="charges-titles col-9">
                        <div className="charge-title">Subscription Type:</div>
                        {showCoupon && (
                          <>
                            <div className="charge-amount">Subscription:</div>
                            <div className="charge-amount">Coupon:</div>
                          </>
                        )}
                        <div className="charge-title">
                          <strong>Charge at the end of the trial:</strong>
                        </div>
                        <div className="sales-taxes-title">
                          (Plus applicable sales taxes)
                        </div>
                      </div>
                      <div className="charges-amounts amount-col">
                        <div className="charge-amount">
                          {selectedPlan.interval === 'year'
                            ? 'Annual'
                            : selectedPlan.interval_count === 1
                              ? 'Monthly'
                              : 'Semi-Annual'}
                        </div>
                        {showCoupon && (
                          <>
                            <div>
                              {`$${(
                                selectedPlan.amount / 100 +
                                this.state.tax
                              ).toFixed(2)}`}
                            </div>
                            <div
                              style={{
                                color: coupon?.invalid ? 'red' : '',
                              }}
                            >
                              {coupon.amountOff > 0
                                ? `$${coupon.amountOff.toFixed(2)} off!`
                                : coupon.percentageOff > 0
                                  ? `${coupon.percentageOff}% off!`
                                  : 'Not Valid'}
                            </div>
                          </>
                        )}
                        <div className="charge-amount">
                          <strong>{`$${totalCharge}`}</strong>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* AudioMessage */}
                <AudioMessage />

                {/* ENDCHARGES  */}
                <img
                  src={StripeImg}
                  className="stripeImg"
                  alt="Stripe"
                  height="31"
                  width="150"
                />
              </Col>
              <Col className="form-col" sm={12} xl={6}>
                <div className="planInfo">
                  <div className="planPrice">3 Day Free Trial</div>
                  <div className="freeTrialReminder">
                    No charge today. Cancel anytime.
                  </div>
                </div>
                <div className="imgContainer">
                  <div
                    alt="Bluejacketeer-logo"
                    height="224"
                    width="224"
                    className="shadow-lg logo-bj"
                    style={{ backgroundImage: `url(${pwLogo})` }}
                  />
                </div>
                <div className="stripe-img-container">
                  <img
                    src={StripeImg}
                    className="stripeImg"
                    alt="Stripe"
                    height="31"
                    width="150"
                  />
                </div>

                <div className="subscription-billing-modal-form">
                  <div className="subscription-billing-modal-title">
                    <div className="title">Create your account</div>
                  </div>
                  <i className="icon-close" onClick={this.resetModal} />

                  {/* EMAIL */}
                  <div
                    tabIndex={-1}
                    ref={(input) => {
                      this.emailInput = input;
                    }}
                  >
                    <Input
                      id="email"
                      type="email"
                      value={this.state.email}
                      className={styleEmailInput}
                      placeholder="Email"
                      onChange={(e) => {
                        const emailTrim = e.target.value.trim();
                        this.onChange({ email: emailTrim });
                      }}
                      onBlur={(e) => {
                        this.onBlurCheck({ email: e.target.value });
                      }}
                      style={this.fieldIsRequired('email')}
                    />
                    {this.state.email &&
                      this.state.emailError.isError === false &&
                      this.state.emailSuggestion.isSuggestion === true && (
                        <div className="email-suggestion">
                          Did you mean:{' '}
                          <span>{this.state.emailSuggestion.suggestion}</span> ?
                        </div>
                      )}
                  </div>

                  {/* PASSWORD */}
                  <div
                    tabIndex={-1}
                    ref={(input) => {
                      this.passwordInput = input;
                    }}
                  >
                    <div
                      className={
                        !this.state.passwordError
                          ? 'password-input-container'
                          : 'password-input-container input-error'
                      }
                      style={this.fieldIsRequired('password')}
                    >
                      <Input
                        required
                        type={this.state.passwordInputType}
                        value={this.state.password}
                        className="form-control password-input"
                        placeholder="Create Password"
                        onChange={(e) => {
                          this.onChange({ password: e.target.value });
                        }}
                        onBlur={(e) => {
                          this.onBlurCheck({ password: e.target.value });
                        }}
                      />
                      <i
                        className="material-icons warning-icon"
                        id="warning-icon"
                      >
                        error_outline
                      </i>
                      {this.renderToolTip()}
                      <i
                        className="material-icons material-icons-outlined password-icon"
                        onClick={this.togglePasswordVisibility}
                      >
                        {this.state.showPassword
                          ? 'visibility_off'
                          : 'visibility'}
                      </i>
                    </div>
                  </div>

                  {/* SUBSCRIPTION PLAN */}
                  <div
                    tabIndex={-1}
                    ref={(input) => {
                      this.selectedPlanInput = input;
                    }}
                  >
                    <div className="selector-container ">
                      <select
                        ref={this.planSelectorRef}
                        required
                        className={
                          this.state.highlightPlanSelector
                            ? 'form-control form-control-highlight'
                            : 'form-control'
                        }
                        value={selectedPlan.id}
                        onChange={(e) => {
                          this.handlePlanSelection(e.target.value);
                        }}
                        data-test="pricing-dropdown"
                        style={this.fieldIsRequired('selectedPlan')}
                      >
                        <option value="" disabled>
                          Select Pricing Plan
                        </option>
                        {showPlans.map((plan) => {
                          const label = `${plan.product.name} - $${(
                            plan.amount / 100
                          ).toFixed(2)} ${
                            plan.interval === 'month'
                              ? plan.interval_count === 6
                                ? 'per 6 months'
                                : 'per month'
                              : 'per year'
                          } plus tax`;
                          return (
                            <option key={plan.id} value={plan.id}>
                              {label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  {/* COUPON */}
                  <div>
                    {this.state.selectedPlan.id ? (
                      !this.state.showInput ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <button
                            className="btn btn-apply-code-newuser px-2 py-3 m-0"
                            onClick={() => this.setState({ showInput: true })}
                          >
                            Apply Code
                          </button>
                        </div>
                      ) : (
                        <div style={{ display: 'flex' }}>
                          <Input
                            type="text"
                            className="form-control"
                            value={this.state.couponCode}
                            placeholder="Coupon Code"
                            onChange={(e) => {
                              this.onChange({ couponCode: e.target.value });
                              this.setState({ couponChanged: true });
                            }}
                            disabled={this.state.isInputDisabled}
                            style={{
                              marginRight: '10px',
                              backgroundColor: this.state.isInputDisabled
                                ? 'lightgreen'
                                : '',
                            }}
                          />

                          <button
                            className="btn btn-apply-code-newuser px-2 py-3 m-0 "
                            onClick={() => this.checkCoupon()}
                            disabled={this.state.isInputDisabled}
                            style={{
                              marginRight: '10px',
                              backgroundColor: this.state.isInputDisabled
                                ? 'lightgray'
                                : '',
                              pointerEvents: this.state.isInputDisabled
                                ? 'none'
                                : 'auto',
                            }}
                          >
                            Apply Code
                          </button>
                        </div>
                      )
                    ) : null}
                  </div>

                  <div className="payment-details-title">
                    <div className="title">Payment details</div>
                  </div>

                  {/* FIRST NAME */}
                  <div
                    tabIndex={-1}
                    ref={(input) => {
                      this.firstNameInput = input;
                    }}
                  >
                    <Input
                      type="text"
                      className="form-control"
                      value={this.state.firstName}
                      placeholder="First name"
                      onChange={(e) => {
                        this.onChange({ firstName: e.target.value });
                      }}
                      style={this.fieldIsRequired('firstName')}
                    />
                  </div>
                  {/* LAST NAME */}
                  <div
                    tabIndex={-1}
                    ref={(input) => {
                      this.lastNameInput = input;
                    }}
                  >
                    <Input
                      type="text"
                      className="form-control"
                      value={this.state.lastName}
                      placeholder="Last name"
                      onChange={(e) => {
                        this.onChange({ lastName: e.target.value });
                      }}
                      style={this.fieldIsRequired('lastName')}
                    />
                  </div>
                  {/* ADRESS */}
                  <div
                    tabIndex={-1}
                    ref={(input) => {
                      this.addressInput = input;
                    }}
                  >
                    <Input
                      required={!isFullDiscount}
                      type="text"
                      value={this.state.address}
                      className="form-control"
                      placeholder="Street Address"
                      onChange={(e) => {
                        this.onChange({ address: e.target.value });
                      }}
                      style={this.fieldIsRequired('address')}
                    />
                  </div>
                  {/* CITY */}
                  <div
                    tabIndex={-1}
                    ref={(input) => {
                      this.cityInput = input;
                    }}
                  >
                    <Input
                      required={!isFullDiscount}
                      type="text"
                      value={this.state.city}
                      className="form-control"
                      placeholder="City"
                      onChange={(e) => {
                        this.onChange({ city: e.target.value });
                      }}
                      style={this.fieldIsRequired('city')}
                    />
                  </div>
                  {/* STATE */}
                  <div>
                    <div
                      className="selector-container"
                      ref={(select) => {
                        this.stateSelectInput = select;
                      }}
                    >
                      <RegionDropdown
                        country={this.state.country}
                        value={this.state.state}
                        onChange={(val) => this.selectRegion(val)}
                        classes={`selectors  ${
                          this.state.state ? 'black-text' : ''
                        } ${isFirefox ? 'is-firefox' : ''} ${
                          this.state.missingFields.includes('state')
                            ? 'border-red'
                            : 'borderNone'
                        }`}
                        defaultOptionLabel="Select State"
                        id="stateSelect"
                        data-test="state-dropdown"
                      />
                    </div>
                  </div>
                  {/* COUNTRY */}
                  <div
                    ref={(select) => {
                      this.countrySelectInput = select;
                    }}
                  >
                    <div className="selector-container">
                      <CountryDropdown
                        blacklist={['CU', 'UA', 'IR', 'KP', 'SY']}
                        value={this.state.country}
                        onChange={(countryName) => {
                          this.selectCountry(countryName);
                          const normalizedCountryName = countryName
                            .normalize('NFD')
                            .replace(/\p{Diacritic}/gu, '');
                          const country = countryCodes.find(
                            (c) => c.name === normalizedCountryName,
                          );
                          this.state.countryShortCode = country?.code;
                        }}
                        classes={`selectors ${
                          this.state.country ? 'black-text' : ''
                        } ${isFirefox ? 'is-firefox' : ''} ${
                          this.state.missingFields.includes('country')
                            ? 'border-red'
                            : 'borderNone'
                        }`}
                        data-test="country-dropdown"
                      />
                    </div>
                  </div>

                  <div className="phone-number-container">
                    {/* COUNTRY CODE */}
                    <div className="selector-container country-code">
                      <select
                        className="form-control"
                        value={this.state.countryCode}
                        onChange={(e) => {
                          this.onChange({
                            countryCode: e.target.value,
                          });
                        }}
                        data-test="country-code-dropdown"
                      >
                        {countryCodes.map((countryCode) => (
                          <option
                            key={countryCode.code}
                            value={countryCode.dial_code}
                          >
                            {`${countryCode.code} (${countryCode.dial_code})`}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* PHONE NUMBER */}
                    <Input
                      type="text"
                      maxLength={16} // 12 digits + 4 characters for formatting
                      value={this.state.phoneNumber}
                      className="form-control phone-number"
                      placeholder="Phone Number"
                      onChange={(e) => {
                        this.onChange({ phoneNumber: e.target.value });
                      }}
                    />
                  </div>

                  {/* HIGHEST EDUCATION LEVEL */}
                  <div
                    ref={(select) => {
                      this.highestEducationLevelSelectInput = select;
                    }}
                  >
                    <div className="selector-container">
                      <select
                        className="form-control"
                        value={this.state.highestEducationLevel}
                        required
                        onChange={(e) => {
                          this.onChange({
                            highestEducationLevel: e.target.value,
                          });
                        }}
                        data-test="education-level-dropdown"
                        style={this.fieldIsRequired('highestEducationLevel')}
                      >
                        <option value="" disabled>
                          Highest Education Level ( * )
                        </option>
                        <option value="High school diploma or GED/HS equivalency">
                          High school diploma or GED/HS equivalency
                        </option>
                        <option value="Some college, but no degree">
                          Some college, but no degree
                        </option>
                        <option value="Career / Technical Certificate">
                          Career / Technical Certificate
                        </option>
                        <option value="Associate's degree">
                          Associate's degree
                        </option>
                        <option value="Bachelor's degree">
                          Bachelor's degree
                        </option>
                        <option value="Master's degree or higher">
                          Master's degree or higher
                        </option>
                      </select>
                    </div>
                  </div>

                  {/* CURRENT ENROLLMENT STATUS */}
                  <div
                    ref={(select) => {
                      this.currentEnrollmentStatusSelectInput = select;
                    }}
                  >
                    <div className="selector-container">
                      <select
                        className="form-control"
                        value={this.state.currentEnrollmentStatus}
                        required
                        onChange={(e) => {
                          this.onChange({
                            currentEnrollmentStatus: e.target.value,
                          });
                        }}
                        data-test="current-enrollment-status-dropdown"
                        style={this.fieldIsRequired('currentEnrollmentStatus')}
                      >
                        <option value="" disabled>
                          Current Enrollment Status ( * )
                        </option>
                        <option value="Yes, a certificate program">
                          Yes, a certificate program
                        </option>
                        <option value="Yes, an associate's degree program">
                          Yes, an associate's degree program
                        </option>
                        <option value="Yes, a bachelor's degree program">
                          Yes, a bachelor's degree program
                        </option>
                        <option value="Yes, a master's degree or doctorate program">
                          Yes, a master's degree or doctorate program
                        </option>
                        <option value="No, and I am not interested in enrolling in a degree program in the future">
                          No, and I am not interested in enrolling in a degree
                          program in the future
                        </option>
                        <option value="No, but I am interested in enrolling in the future">
                          No, but I am interested in enrolling in the future
                        </option>
                      </select>
                    </div>
                  </div>
                  {/* CCNUMBER */}
                  <div
                    tabIndex={-1}
                    ref={(input) => {
                      this.cardNumberInput = input;
                    }}
                  >
                    <ElementCard
                      errorMessage={this.errorMessage}
                      dataCard={this.dataCard}
                      cardData={cardData}
                      style={this.fieldIsRequired('tokenCard')}
                      onCardReady={this.handleCardReady}
                      setLoadingStripeToken={(value) =>
                        this.setState({ isLoadingTokenCard: value })
                      }
                    />
                  </div>

                  {/* CHARGES */}
                  <div className="charges">
                    {selectedPlan.id === '' ? (
                      <>Select a Pricing Plan</>
                    ) : (
                      <>
                        <div className="line-item">
                          <span className="item">Subscription Type:</span>
                          <span className="cost">
                            {selectedPlan.interval === 'year'
                              ? 'Annual'
                              : selectedPlan.interval_count === 1
                                ? 'Monthly'
                                : 'Semi-Annual'}
                          </span>
                        </div>
                        {showCoupon && (
                          <>
                            <div className="line-item">
                              <span className="item">Subscription:</span>
                              <span className="cost">
                                {`$${(
                                  selectedPlan.amount / 100 +
                                  this.state.tax
                                ).toFixed(2)}`}
                              </span>
                            </div>
                            <div className="line-item">
                              <span className="item">Coupon:</span>
                              <span className="cost">
                                {coupon.amountOff > 0
                                  ? `$${coupon.amountOff.toFixed(2)} off!`
                                  : coupon.percentageOff > 0
                                    ? `${coupon.percentageOff}% off!`
                                    : 'Not Valid'}
                              </span>
                            </div>
                          </>
                        )}
                        <div className="line-item">
                          <span className="item">
                            <strong>Charge at the end of the trial:</strong>
                          </span>
                          <span className="cost">
                            <strong>{`$${totalCharge}`}</strong>
                          </span>
                        </div>
                        <div className="line-item">
                          <span className="sales-taxes-title">
                            (Plus applicable sales taxes)
                          </span>
                        </div>
                      </>
                    )}
                  </div>

                  {/* ERROR MESSAGES */}
                  <div className="error-messages">
                    {this.state.emailExistsError && (
                      <span>
                        Account already exists. Please{' '}
                        <b>
                          <Link
                            to="/login"
                            className="cursor-pointer"
                            onClick={this.resetModal}
                          >
                            login
                          </Link>
                        </b>{' '}
                        to renew your subscription
                      </span>
                    )}
                    {this.state.emailError.isError &&
                      !this.state.emailExistsError && (
                        <span>{this.state.emailError.message}</span>
                      )}
                    {this.state.passwordError && !this.props.existsEmail && (
                      <span>Password doesn't meet criteria</span>
                    )}
                    {this.props.subscriptionMessage && (
                      <span>{this.props.subscriptionMessage}</span>
                    )}
                    {this.state.errorMessage && (
                      <span>{this.state.errorMessage}</span>
                    )}
                    {this.state.missingFields &&
                      this.state.missingFields.length > 0 && (
                        <span>
                          There are required fields that haven't been filled
                        </span>
                      )}
                  </div>

                  {/* FOOTER */}

                  {/* DISCLAIMER */}
                  <div className="subscription-billing-disclaimer">
                    <div>
                      Your Promotion Wingman subscription will be a recurring
                      charge that will start after your 3-day free trial
                      expires. You can cancel anytime by going to “Account
                      Settings” and clicking on “Manage My Subscription”, then
                      "Edit My Subscription", or by contacting us at{' '}
                      <a
                        href="mailto:support@promotionwingman.com"
                        className="mailto"
                      >
                        support@promotionwingman.com
                      </a>
                      .
                    </div>
                    <br />
                    {this.state.phoneNumber && (
                      <>
                        <div>
                          By submitting this form, I agree that Kaplan North
                          America, LLC may contact me regarding educational
                          services by telephone and/or text message utilizing
                          automated technology at the telephone number(s)
                          provided above. I understand this consent is not
                          required to sign up for a free trial or purchase goods
                          or services from Kaplan North America, LLC. If I
                          reside outside the U.S., I consent to the transfer of
                          my data to the U.S.{' '}
                          <a
                            className="terms-link"
                            href="https://kaplan.com/privacy-policy"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <strong>Privacy Policy</strong>
                          </a>{' '}
                          governs the submission and handling of this data.
                        </div>
                        <br />
                      </>
                    )}
                    <div>
                      Your 3 day free trial will begin when you click “Sign up
                      now” and end three days from that date. By clicking “Sign
                      up now” below, you authorize regularly scheduled
                      subscription fee charges to your credit card or bank
                      account at the end of the free trial to continue the
                      subscription until you cancel.
                    </div>
                    <br />
                    <div>
                      <input
                        type="checkbox"
                        id="disclaimer-terms-privacy"
                        value={this.state.disclaimer}
                        onChange={() =>
                          this.setState({ disclaimer: !this.state.disclaimer })
                        }
                        data-test="agree-terms-checkbox"
                      />
                      <label
                        htmlFor="disclaimer-terms-privacy"
                        className={this.state.textRed ? 'text-red' : ''}
                      >
                        I agree to the{' '}
                        <a
                          className="terms-link"
                          href="https://promotionwingman.com/terms-of-service/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <strong>Terms</strong>
                        </a>{' '}
                        and{' '}
                        <a
                          className="terms-link"
                          href="https://kaplan.com/privacy-policy"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <strong>Privacy Policy.</strong>
                        </a>
                      </label>
                    </div>
                    <br />
                    <div
                      className="subscription-billing-modal-footer"
                      data-test="signup-button-container"
                    >
                      <button
                        className={`btn btn-primary loading-${this.props.subscriptionWaiting}
                         ${this.props.subscriptionWaiting ? 'disabled-signup' : ''}
                          ${
                            !this.state.disclaimer
                              ? 'cursor-not-allowed'
                              : this.props.subscriptionWaiting ||
                                  this.state.isLoadingTokenCard
                                ? 'cursor-waiting'
                                : ''
                          }
                        `}
                        type="submit"
                        disabled={
                          this.props.subscriptionWaiting ||
                          this.state.isLoadingTokenCard
                        }
                        onClick={() => {
                          if (!this.state.disclaimer) {
                            this.setTextRed();
                          } else {
                            this.checkCoupon();
                            this.validateData(true);
                          }
                        }}
                        data-test="signup-button"
                      >
                        {this.renderButtonText()}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
        <ModalCoupon
          isOpen={this.state.couponInvalid}
          onClose={() => {
            this.props.setCoupon('');
            this.setState({
              couponCode: '',
              couponInvalid: false,
              isInputDisabled: false,
            });
          }}
          coupon={coupon}
          validateData={() => this.validateData(false)}
        />
      </div>
    );
  }
}

export default SubscriptionBillingModal;
